import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=08a4b350&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a4b350')) {
      api.createRecord('08a4b350', component.options)
    } else {
      api.reload('08a4b350', component.options)
    }
    module.hot.accept("./PasswordResetForm.vue?vue&type=template&id=08a4b350&", function () {
      api.rerender('08a4b350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PasswordResetForm.vue"
export default component.exports